"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_redux_1 = require("react-redux");
var Stores = require("../store/ServiceManage");
var reactstrap_1 = require("reactstrap");
var sweetalert2_1 = require("sweetalert2");
var ModalConfirmDeleteServiceComponent = /** @class */ (function (_super) {
    __extends(ModalConfirmDeleteServiceComponent, _super);
    function ModalConfirmDeleteServiceComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            isOpen: false,
            serId: "",
            user: "",
            pass: "",
            isSave: false,
            classSpinner: "d-none"
        };
        _this.toggleModal = _this.toggleModal.bind(_this);
        _this.SaveClick = _this.SaveClick.bind(_this);
        _this.handleChangeUser = _this.handleChangeUser.bind(_this);
        _this.handleChangePass = _this.handleChangePass.bind(_this);
        return _this;
    }
    ModalConfirmDeleteServiceComponent.prototype.toggleModal = function () {
        this.setState({
            isOpen: !this.state.isOpen,
            serId: this.props.service_id
        });
    };
    ModalConfirmDeleteServiceComponent.prototype.handleChangeUser = function (event) {
        this.setState({ user: event.target.value });
    };
    ModalConfirmDeleteServiceComponent.prototype.handleChangePass = function (event) {
        this.setState({ pass: event.target.value });
    };
    ModalConfirmDeleteServiceComponent.prototype.SaveClick = function () {
        if (this.state.user != "sonarinno" || this.state.pass != "123456") {
            sweetalert2_1.default.fire('Error', 'Username or Password incorrect.', 'error');
            return;
        }
        this.setState({
            isSave: true,
            classSpinner: "d-inline-block"
        });
        this.props.requestFunction(this.state.serId, "", "", "DELETE");
    };
    ModalConfirmDeleteServiceComponent.prototype.render = function () {
        if (this.props.isOpenModalDelete) {
            this.props.afterOpenModalDelete();
            this.toggleModal();
        }
        if (this.props.isLoading && this.state.isSave) {
            this.props.BindData();
            this.toggleModal();
            this.setState({
                isSave: false
            });
        }
        return (React.createElement("div", null,
            React.createElement(reactstrap_1.Modal, { isOpen: this.state.isOpen },
                React.createElement(reactstrap_1.ModalHeader, { toggle: this.toggleModal },
                    "Delete Service ",
                    React.createElement("span", { style: { color: "red" } }, this.props.serviceSelected.service_name)),
                React.createElement(reactstrap_1.ModalBody, null,
                    React.createElement("label", { htmlFor: "txtUser" },
                        React.createElement("b", null, "User Name")),
                    React.createElement("input", { type: "text", id: "txtUser", className: "form-control", value: this.state.user, onChange: this.handleChangeUser }),
                    React.createElement("label", { htmlFor: "txtPass" },
                        React.createElement("b", null, "Password")),
                    React.createElement("input", { type: "text", id: "txtPass", className: "form-control", value: this.state.pass, onChange: this.handleChangePass })),
                React.createElement(reactstrap_1.ModalFooter, null,
                    React.createElement(reactstrap_1.Button, { color: "danger", onClick: this.SaveClick },
                        React.createElement(reactstrap_1.Spinner, { className: this.state.classSpinner, style: { width: '20px', height: '20px' } }),
                        ' ',
                        "Delete"),
                    ' ',
                    React.createElement(reactstrap_1.Button, { color: "secondary", onClick: this.toggleModal }, "Cancel")))));
    };
    return ModalConfirmDeleteServiceComponent;
}(React.PureComponent));
exports.default = react_redux_1.connect(function (state) { return state.service; }, Stores.actionCreators)(ModalConfirmDeleteServiceComponent);
//# sourceMappingURL=ModalConfirmDeleteServiceComponent.js.map